import { useInboxModuleType } from "@/composables/v2.1/useInboxModuleType";
import useUnreadChats from "@/composables/v2.1/useUnreadChats";
// @ts-ignore
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
import i18n from "@/libs/i18n";
import { useChatsStore } from "@/store/useChatsStore";
import { ChatDto } from "@saysimple-platform/dtos";
import { ComponentInstance, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification/composition";

const isDeletePending = ref(false);

export default function useDeleteChat(root: ComponentInstance) {
    const { publicApiEndpointPath } = useInboxModuleType();
    const toast = useToast();
    const chatsStore = useChatsStore();
    const { isUpdatingChatId } = storeToRefs(chatsStore);

    const deleteChat = (chatId: number): void => {
        root.$bvModal
            .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                title: i18n.t("confirm.Are you sure?"),
                cancelTitle: i18n.t("confirm.Cancel"),
                cancelVariant: "light",
                okTitle: i18n.t("confirm.Yes, delete"),
                hideHeaderClose: false,
                headerCloseVariant: "light",
                centered: true,
            })
            .then((result) => {
                if (result) {
                    isUpdatingChatId.value = chatId;
                    isDeletePending.value = true;

                    chatsStore.deleteChat(chatId);
                    chatsStore.closeChat(chatId);

                    const { deleteUnreadChat } = useUnreadChats();
                    deleteUnreadChat(chatId);

                    return axios
                        .post<ChatDto>(`${publicApiEndpointPath.value}/delete`, { chatId: chatId })
                        .then(({ data }) => {
                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("Delete"),
                                    text: i18n.t("entities.conversation.is-deleted"),
                                    icon: "check",
                                    variant: "success",
                                },
                            });

                            return data;
                        })
                        .catch((error) => {
                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("Delete"),
                                    text: i18n.t("entities.conversation.could-not-delete"),
                                    icon: "times",
                                    variant: "error",
                                },
                            });

                            return error;
                        })
                        .finally(() => {
                            isUpdatingChatId.value = undefined;
                            isDeletePending.value = false;
                        });
                }
            });
    };

    return {
        deleteChat,
        isDeletePending,
    };
}
